export default "__VITE_ASSET__Bvog8JEC__"